export default {
	data() {
		return {

		}
	},
	mounted() {

	},
	beforeDestroy() {

	},
	activated() {

	},
	deactivated() {

	},
	methods: {
		jump(questionindex, jump) {
			if(jump == 'prve') {
				this.prveQuestion();
				return
			}
			if(jump == 'next') {
				this.nextQuestion();
				return
			}
			if(jump == 'jump') {
				this.answerQuestion(questionindex);
				return
			}
		},
		answerQuestion(questionindex) {
			if(!this.uploadFlag) {
				if(this.questionindex != questionindex) {
					this.questionindex = questionindex;
					this.checkOver();
				}
			} else {
				this.$message.info('正在上传文件。。。')
			}
		},
		prveQuestion() {
			var questionindex = this.questionindex - 1;
			this.answerQuestion(questionindex)
		},
		nextQuestion() {
			var questionindex = this.questionindex + 1;
			this.answerQuestion(questionindex)
		},
		questionWhere(item, index) {
			if(this.questionindex == index) {
				return 'doing'
			}
			if(this.questionove.indexOf(index) != -1) {
				return 'over'
			}
		},
		questionStatus(item, index) {
			var className = ''
			if(item.topicType == '1' || item.topicType == '2' || item.topicType == '3') {
				if(item.chooseRight == '1') {
					className = 'success'
				} else {
					className = 'error'
				}
			} else {
				if(item.userScore != null) {
					className = 'warning'
				} else {
					className = 'info'
				}
			}
			if(this.questionindex == index) {
				className += ' doing'
			}
			return className
		},
		questionErrorStatus(item, index) {
			if(this.questionindex == index) {
				return 'doing'
			} else {
				return ''
			}
		},
		uploadAnswer(filearr) {
			var index = this.questionindex;
			var qusetionlist = this.qusetionlist;
			qusetionlist[index].filesurl = JSON.stringify(filearr);
			qusetionlist[index].filearr = filearr;
			qusetionlist[index].over = true;
			this.$set(qusetionlist, index, qusetionlist[index])
			this.checkOver();
		},
		formFileRemove() {
			var index = this.questionindex;
			var qusetionlist = this.qusetionlist;
			qusetionlist[index].filesurl = '';
			qusetionlist[index].filearr = [];
			if(qusetionlist[index].userAnswer.length <= 0) {
				qusetionlist[index].over = false
			}
			this.$set(qusetionlist, index, qusetionlist[index])
			this.checkOver();
		},
		singleAnswer(it, i, index) {
			var qusetionlist = this.qusetionlist;
			var choose = [it.label];
			qusetionlist[index].choose = choose;
			qusetionlist[index].over = true;
			this.$set(qusetionlist, index, qusetionlist[index])
			this.checkOver();
		},
		multipleAnswer(it, i, index) {
			var qusetionlist = this.qusetionlist;
			var choose = qusetionlist[index].choose;
			if(choose.indexOf(it.label) == -1) {
				choose.push(it.label)
			} else {
				var deleteIndex = choose.indexOf(it.label);
				choose.splice(deleteIndex, 1)
			}
			choose = choose.sort();
			qusetionlist[index].choose = choose;
			if(choose.length > 0) {
				qusetionlist[index].over = true;
			} else {
				qusetionlist[index].over = false;
			}
			this.$set(qusetionlist, index, qusetionlist[index])
			this.checkOver();
		},
		blanksAnswer(index) {
			var qusetionlist = this.qusetionlist;
			if(qusetionlist[index].userAnswer.length > 0) {
				qusetionlist[index].over = true;
			} else {
				qusetionlist[index].over = false;
			}
			this.checkOver();
		},
		formInit() { //考试题
			return new Promise((resolve, reject) => {
				var qusetionlist = this.qusetionlist;
				qusetionlist.map(item => {
					item.over = false;
					item.overdata = false;
					item.choose = [];
					item.filesurl = '';
					item.filearr = [];
					item.userAnswer = '';
					if(item.topicType == 4 || item.topicType == 5) {
						this.isSubjectiveItem = true;
					}
					if(item.isFile == 1 && item.fileName != null) {
						var files = JSON.parse(item.fileName);
						item.files = files;
						var openfiles = [];
						files.map(item => {
							var openurl = this.baseurl + item.url;
							openfiles.push(openurl)
						})
						item.openfiles = openfiles;
					}
					var answerlist = [];
					if(item.optionA != '' && item.optionA != null) {
						if(item.optionA.indexOf('@') == -1) {
							answerlist[0] = {
								type: '1',
								label: 'A',
								value: item.optionA,
							}
						} else {
							answerlist[0] = {
								type: '2',
								label: 'A',
								value: item.optionA.slice(1),
							}
						}
					}
					if(item.optionB != '' && item.optionB != null) {
						if(item.optionB.indexOf('@') == -1) {
							answerlist[1] = {
								type: '1',
								label: 'B',
								value: item.optionB,
							}
						} else {
							answerlist[1] = {
								type: '2',
								label: 'B',
								value: item.optionB.slice(1),
							}
						}
					}
					if(item.optionC != '' && item.optionC != null) {
						if(item.optionC.indexOf('@') == -1) {
							answerlist[2] = {
								type: '1',
								label: 'C',
								value: item.optionC,
							}
						} else {
							answerlist[2] = {
								type: '2',
								label: 'C',
								value: item.optionC.slice(1),
							}
						}
					}
					if(item.optionD != '' && item.optionD != null) {
						if(item.optionD.indexOf('@') == -1) {
							answerlist[3] = {
								type: '1',
								label: 'D',
								value: item.optionD,
							}
						} else {
							answerlist[3] = {
								type: '2',
								label: 'D',
								value: item.optionD.slice(1),
							}
						}
					}
					if(item.optionE != '' && item.optionE != null) {
						if(item.optionE.indexOf('@') == -1) {
							answerlist[4] = {
								type: '1',
								label: 'E',
								value: item.optionE,
							}
						} else {
							answerlist[4] = {
								type: '2',
								label: 'E',
								value: item.optionE.slice(1),
							}
						}
					}
					if(item.optionF != '' && item.optionF != null) {
						if(item.optionF.indexOf('@') == -1) {
							answerlist[5] = {
								type: '1',
								label: 'F',
								value: item.optionF,
							}
						} else {
							answerlist[5] = {
								type: '2',
								label: 'F',
								value: item.optionF.slice(1),
							}
						}
					}
					item.answerlist = answerlist;
				})
				this.qusetionlist = qusetionlist;
				setTimeout(_ => {
					resolve()
				}, 600)
			})
		},
		formInitOver() { //考试结果
			var qusetionlist = this.qusetionlist;
			qusetionlist.map(item => {
				item.over = false;
				item.filesurl = '';
					item.filearr = [];
				if(item.topicType != 4 && item.topicType != 5) {
					if(!item.userAnswer) {
						item.choose = [];
					} else {
						item.choose = item.userAnswer.split('')
					}
					if(item.userAnswer && item.userAnswer == item.answer) {
						item.chooseRight = 1
					} else {
						item.chooseRight = 0
					}
					if(item.userAnswerFile && item.userAnswerFile != '') {
						item.filearr = JSON.parse(item.userAnswerFile);
						item.filesurl = item.userAnswerFile;
					}
				}
				if(item.topicType == 5 && item.userAnswerFile && item.userAnswerFile != '') {
					item.userAnswerFilearr = JSON.parse(item.userAnswerFile);
				}
				if(item.isFile == 1 && item.fileName != null) {
					var files = JSON.parse(item.fileName);
					item.files = files;
					var openfiles = [];
					files.map(item => {
						var openurl = this.baseurl + item.url;
						openfiles.push(openurl)
					})
					item.openfiles = openfiles;
				}
				var answerlist = [];
				if(item.optionA != '' && item.optionA != null) {
					if(item.optionA.indexOf('@') == -1) {
						answerlist[0] = {
							type: '1',
							label: 'A',
							value: item.optionA,
						}
					} else {
						answerlist[0] = {
							type: '2',
							label: 'A',
							value: item.optionA.slice(1),
						}
					}
				}
				if(item.optionB != '' && item.optionB != null) {
					if(item.optionB.indexOf('@') == -1) {
						answerlist[1] = {
							type: '1',
							label: 'B',
							value: item.optionB,
						}
					} else {
						answerlist[1] = {
							type: '2',
							label: 'B',
							value: item.optionB.slice(1),
						}
					}
				}
				if(item.optionC != '' && item.optionC != null) {
					if(item.optionC.indexOf('@') == -1) {
						answerlist[2] = {
							type: '1',
							label: 'C',
							value: item.optionC,
						}
					} else {
						answerlist[2] = {
							type: '2',
							label: 'C',
							value: item.optionC.slice(1),
						}
					}
				}
				if(item.optionD != '' && item.optionD != null) {
					if(item.optionD.indexOf('@') == -1) {
						answerlist[3] = {
							type: '1',
							label: 'D',
							value: item.optionD,
						}
					} else {
						answerlist[3] = {
							type: '2',
							label: 'D',
							value: item.optionD.slice(1),
						}
					}
				}
				if(item.optionE != '' && item.optionE != null) {
					if(item.optionE.indexOf('@') == -1) {
						answerlist[4] = {
							type: '1',
							label: 'E',
							value: item.optionE,
						}
					} else {
						answerlist[4] = {
							type: '2',
							label: 'E',
							value: item.optionE.slice(1),
						}
					}
				}
				if(item.optionF != '' && item.optionF != null) {
					if(item.optionF.indexOf('@') == -1) {
						answerlist[5] = {
							type: '1',
							label: 'F',
							value: item.optionF,
						}
					} else {
						answerlist[5] = {
							type: '2',
							label: 'F',
							value: item.optionF.slice(1),
						}
					}
				}
				item.answerlist = answerlist;
			})
			this.qusetionlist = qusetionlist;
			this.loading = false;
		},
	}
}